import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=769a8848&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&id=769a8848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a8848",
  null
  
)

export default component.exports